import { useRef, useState } from "react";
import { Button, Form, ListGroup } from "react-bootstrap";
import { editFolder, getFiles, removeFolder, setFolder } from "../../context/fetch/fetchAssets";
import { useAssetsValue } from "../../context/reducers/assetsContext";
import { useNavigate } from "react-router-dom";
import FolderItem from "./FolderItem";

const noop = () => {};

const FolderList = (props) => {
  const [showSubfolderInput, setShowSubfolderInput] = useState(false);
  const [state, dispatch] = useAssetsValue();
  const navigate = useNavigate();
  const subfolderNameRef = useRef(null);

  const { folder, setIndex, showInModal, sortQuery, debouncedSearch } = props;
  const hasChildren = folder.children && folder.children.length > 0;
  const isActive = folder.id === state.folder.activeFolderId;
  const hasActiveChild =
    hasChildren && folder.children.some((child) => child.id === state.folder.activeFolderId);
  const isExpanded = isActive || hasActiveChild || showSubfolderInput;

  const handleFolderClick = (folderId) => {
    const id = folderId === state.folder.activeFolderId ? null : folderId;
    const sort = sortQuery
      ? `${sortQuery.columnName}:${sortQuery.sortAsc ? "asc" : "desc"}`
      : undefined;
    getFiles(id, dispatch, navigate, noop, showInModal, sort, debouncedSearch);
  };

  const handleEditSave = (folderId, folderName) => {
    editFolder({ folderId, folderName }, state.folder.list, dispatch, setIndex, navigate);
  };

  const handleRemoveClick = (folderId) => {
    removeFolder(folderId, dispatch, navigate, state.folder);
  };

  const handleAddSubfolder = (e) => {
    e.stopPropagation();
    setShowSubfolderInput(true);
  };

  const handleSaveSubfolder = () => {
    const name = subfolderNameRef.current.value.trim();
    if (name) {
      setFolder(name, dispatch, navigate, props, folder.id);
      setShowSubfolderInput(false);
    }
  };

  const handleCancelSubfolder = () => {
    setShowSubfolderInput(false);
  };

  return (
    <ListGroup variant="flush" className="my-3">
      <ListGroup.Item className="parent-list-group-item">
        <FolderItem
          folder={folder}
          isActive={isExpanded}
          isRootFolder
          showInModal={showInModal}
          onFolderClick={handleFolderClick}
          onAddSubfolder={handleAddSubfolder}
          onEditSave={handleEditSave}
          onRemoveClick={handleRemoveClick}
        />
        {isExpanded && (hasChildren || showSubfolderInput) && (
          <ListGroup variant="flush" className="mt-2 ms-4">
            {hasChildren &&
              folder.children.map((child) => (
                <ListGroup.Item key={child.id} className="py-1 px-0 border-0">
                  <FolderItem
                    folder={child}
                    isActive={child.id === state.folder.activeFolderId}
                    showInModal={showInModal}
                    onFolderClick={handleFolderClick}
                    onEditSave={handleEditSave}
                    onRemoveClick={handleRemoveClick}
                  />
                </ListGroup.Item>
              ))}
            {showSubfolderInput && (
              <ListGroup.Item className="py-1 px-0 border-0">
                <Form
                  className="d-flex align-items-center gap-1 subfolder-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSaveSubfolder();
                  }}
                >
                  <Form.Control
                    type="text"
                    placeholder="Subfolder name"
                    size="sm"
                    ref={subfolderNameRef}
                    maxLength={30}
                    autoFocus
                  />
                  <Button type="submit" variant="outline-info" size="sm">
                    Save
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={handleCancelSubfolder}>
                    X
                  </Button>
                </Form>
              </ListGroup.Item>
            )}
          </ListGroup>
        )}
      </ListGroup.Item>
    </ListGroup>
  );
};

export default FolderList;
